import Vue from 'vue';
import VueRouter from 'vue-router';
import { getAccessToken } from '@/services/axios';
import authenticateRoutes from '@/router/web/authenticate-routes';
import authenticatedRoutes from '@/router/web/authenticated-routes';
import publicRoutes from '@/router/web/public-routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...publicRoutes,
    ...authenticateRoutes,
    ...authenticatedRoutes,
    {
      path: '/*',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: "portal" */ '@/views/404/Error404.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const token = getAccessToken();
  const hasMeta = (name: string): boolean => to.matched.some((record) => record.meta[name]);

  if (hasMeta('authenticated') && token == null) {
    next({ name: 'Login' });
  }

  // if (hasMeta('guest') && token != null) {
  //   next({ name: 'Home' });
  // }
  next();
});

export default router;
